module.exports = __webpack_public_path__ + "static/img/SupplyAndDemand.38a94296.png";